if (!global._babelPolyfill) {
	require('@babel/polyfill');
}

import React from 'react';
import { hydrate } from 'react-dom';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import configureStore from '../redux/store';
import HeaderBarApp from '.';
import { V2_APPLICATION_PATH } from 'AppConstants';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'UtilityComponents/Util';

const preloadedState = window.__PRELOADED_STATE__;
const { store } = configureStore(preloadedState);
delete window.__PRELOADED_STATE__;
Loadable.preloadReady().then(() => {
	if (typeof window !== 'undefined') {
		hydrate(
			<BrowserRouter basename={V2_APPLICATION_PATH}>
				<Provider store={store}>
					<StyleSheetManager shouldForwardProp={shouldForwardProp}>
						<HeaderBarApp />
					</StyleSheetManager>
				</Provider>
			</BrowserRouter>,
			document.querySelector('#header')
		);
	}
});
